export default __webpack_public_path__ + "static/media/apply.5df0a34a.jpg";